import React, { useState, useEffect, Component } from "react";
import { Col, Row, Form, Badge, Button, Alert } from "react-bootstrap";
import { FaRegListAlt, FaQuestionCircle } from "react-icons/fa";
import { Link } from "react-router-dom";
import SponsershipList from "../../../Components/SponsershipList";
import { getSponsershipList } from "../../../Services/SponsershipService";
import ListPagination from "../../../Components/Pagination";
import { supportSponsorshipsPerPage } from "../../../Utilities/Helper";
import { SortingAlphabate } from "../../../Components/Shared/SortingAlphabate";

export default function Sponsership() {
  const [sponsership, setSponsership] = useState([]);
  const [totalSponsership, setTotalSponsership] = useState();
  const [showSpinner, setShowSpinner] = useState(true);
  const [currentPage, setCurrentPage] = useState({ value: "", filter: "" });
  const [refreshTable, setRefreshTable] = useState(true);
  const [sort, setSort] = useState({ value: "", filter: "" });
  const [showPagination, setShowPagination] = useState(true);
  const [showHelp, setShowHelp] = useState(false);

  // getting Sponsership list
  useEffect(() => {
    async function sponsershipData() {
      setShowPagination(true);
      const filter =
        "recordperpage=" +
        supportSponsorshipsPerPage +
        currentPage.filter +
        sort.filter;
      getSponsershipList(filter)
        .then((res) => {
          const result = JSON.parse(res.response);
          setShowSpinner(false);
          setSponsership(result.jobSeekers);
          setTotalSponsership(result.totalRecord);
        })
        .catch((err) => {
          setShowSpinner(false);
          console.log(err);
        });
    }
    sponsershipData();
  }, [refreshTable]);

  const sortingChangeHandler = (value) => {
    if (sort.value !== value && value !== "clear") {
      setSort((prev) => ({ value: value, filter: `&sort=${value}` }));
      refreshTableHandler();
    }
    if (sort.value !== value && value === "clear") {
      setSort((prev) => ({ value: value, filter: "" }));
      refreshTableHandler();
    }
  };

  const pageChangeHandler = (page) => {
    if (currentPage.value !== page) {
      setCurrentPage((prev) => ({ value: page, filter: `&page=${page}` }));
      setRefreshTable((prev) => !prev);
      setShowSpinner(true);
    }
  };

  const refreshTableHandler = () => {
    setCurrentPage({ value: "", filter: "" });
    setRefreshTable((prev) => !prev);
    setShowSpinner(true);
    setShowPagination(false);
  };

  return (
    <div className="container p-0">
      <h1 className="page-title">
        Sponsorships{" "}
        <Badge
          pill
          bg="danger"
          className="bg-warning text-white px-3 ml-3 font-weight-normal"
        >
          {totalSponsership}
        </Badge>
        <Button
          variant="link"
          className="p-0 ml-3 d-inline-flex align-items-center"
          onClick={() => setShowHelp(!showHelp)}
          title="About Sponsorships"
        >
          <FaQuestionCircle size={24} className="text-info" />
          <span className="text-info ml-2" style={{ fontSize: '1rem', fontWeight: 'normal' }}>Help</span>
        </Button>
      </h1>
      {(totalSponsership === 0 || showHelp) && (
        <Alert
          variant="info"
          className="my-4"
          dismissible
          onClose={() => setShowHelp(false)}
        >
          <Alert.Heading>About Sponsorships</Alert.Heading>
          <p>
            Each job seeker who wishes to network with employed members of the organization/group, must be "sponsored" by a member of the group that can confirm that the job seeker is also a member of the group.
          </p>
          <p>
            If you are chosen by a job seeker as a potential sponsor, you will receive a "Sponsorship Request". Simply choose "Approve" or "Decline".
          </p>
          <p className="mb-0">
            You will be given the option to be notified when the job seeker you are sponsoring:<br />
            a. Submits a résumé to a posted job<br />
            b. Networks with other support team members<br />
            c. Receives a request for contact from a support team member<br />
            d. And when a job is posted in the jobseeker's chosen job category.
          </p>
        </Alert>
      )}
      <div className="dashboard-wrapper">
        <Row>
          <Col md={12}>
            <div className="dashboard-box dashboard-col-bg sponsership-page">
              <div className="sort d-flex justify-content-end">
                {/* <Form.Group controlId="exampleForm.ControlSelect1" className="w-25">
                <Form.Control as="select" className="inputclass form-control">
                  <option>Sort By</option>
                  <option>Name</option>
                  <option> Email </option>
                  <option>Phone</option>
                  <option> Job Title & Company</option>
                </Form.Control>
              </Form.Group> */}
              </div>
              <div className="d-flex">
                <SponsershipList
                  sponsers={sponsership}
                  showSpinner={showSpinner}
                />
                <SortingAlphabate ChangeHandler={sortingChangeHandler} />
              </div>
              <div className="d-flex">
                {sponsership.length !== 0 && showPagination && (
                  <ListPagination
                    recordPerPage={supportSponsorshipsPerPage}
                    TotalRecord={totalSponsership}
                    className="mt-3"
                    onPageChange={pageChangeHandler}
                  />
                )}
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
}
